import './footer.scss'

export function Footer() {
    return (
        <footer>
            <p>© <span>2023 Медицинский центр лечения грыжи.</span> Все права защищены. Медицинский центр 
                специализируется на лечении пациентов с грыжей с использованием передовых методов, включая РЧА, ВТЭС 
                по Герасимову, озонотерапию и глубокие блокады под контролем УЗИ и рентген навигации.</p>
            <p>
                Адрес: г. Алматы, <br />  Ул. Толе би 289 <br />
                Телефон: <span>87052727775</span> 
            </p>
            <p>
                <span>Медицинский центр лечения грыжи</span> предоставляет квалифицированное лечение пациентов. 
                Процедуры РЧА, ВТЭС по Герасимову, озонотерапия и глубокие блокады проводятся опытными специалистами с 
                применением современных технологий рентген навигации и УЗИ контроля.
            </p>
        </footer>
    )
}